import { render, staticRenderFns } from "./DisableSaasMultiple.vue?vue&type=template&id=729f22b4&"
import script from "./DisableSaasMultiple.vue?vue&type=script&lang=js&"
export * from "./DisableSaasMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports